import { IotData, S3 } from "aws-sdk";
import { mqtt, iot, auth } from "aws-iot-device-sdk-v2";

export const topics = {
  ALERT_TOPIC: "telematics/nextdev/vehicles/+/alert",
  /*
  ALERT_TOPIC: "telematics/local/vehicles/+/alert",
  */
  DATA_TOPIC: "visteon/nextdev/vehicles/+/livelogs",
  DTC_TOPIC: "telematics/nextdev/vehicles/+/dtc",
  SHADOW_DELTA_TOPIC: "$aws/things/+/shadow/update/delta",
  SHADOW_UPDATE_TOPIC: "$aws/things/+/shadow/update",
};

export const ALERT_CATEGORY = {
  VEHICLE_START_STOP_ALERT: "VEHICLE_START_STOP_ALERT",
  DOOR_OPEN_ALERT: "DOOR_OPEN_ALERT",
  LOW_TYRE_PRESSURE_ALERT: "LOW_TYRE_PRESSURE_ALERT",
  SEAT_BELT_ALERT: "SEAT_BELT_ALERT",
  ENGINE_IDLE_ALERT: "ENGINE_IDLE_ALERT",
  CRITICAL_MALFUNCTION_ALERT: "CRITICAL_MALFUNCTION_ALERT",
  BATTERY_ALERT: "BATTERY_ALERT",
  ENGINE_TEMP_ALERT: "ENGINE_TEMP_ALERT",
  SPEED_ALERT: "SPEED_ALERT",
  LAMP_ALERT: "LAMP_ALERT",
  LOW_FUEL_ALERT: "LOW_FUEL_ALERT",
  FUEL_ALERT: "FUEL_ALERT",
  VALET_SPEED_VIOLATION: "VALET_SPEED_VIOLATION",
  // Safety & Protection alerts
  THEFT_PROTECTION_ALERT: "THEFT_PROTECTION_ALERT",
  VEHICLE_DAMAGE_ALERT: "VEHICLE_DAMAGE_ALERT",
  EMERGENCY_CONTACT_ALERT: "EMERGENCY_CONTACT_ALERT",
  TOWING_SERVICE_ALERT: "TOWING_SERVICE_ALERT",
  TOLL_SUPPORT_ALERT: "TOLL_SUPPORT_ALERT",
};

export const iotData = async (credentials) => {
  if (
    !credentials ||
    !credentials.accessKeyId ||
    !credentials.secretAccessKey
  ) {
    console.error("Invalid credentials:", credentials);
    throw new Error("Invalid credentials");
  }

  return new IotData({
    endpoint: process.env.REACT_APP_AWS_ENDPOINT,
    region: process.env.REACT_APP_AWS_REGION,
    credentials,
  });
};

export const triggerAlert = async (payload, creds, category) => {
  const { serialNo, vehicleKey, actual, threshold } = payload || {};
  const iotDataInstance = await iotData(creds);
  return iotDataInstance
    .publish({
      topic: topics.ALERT_TOPIC.replace("+", serialNo),
      payload: JSON.stringify({
        type: "alert",
        serialNo,
        vehicleKey,
        category,
        data: {
          actual,
          threshold,
        },
      }),
      qos: 0,
      retain: false,
    })
    .promise();
};

export const generateUniqSerial = () => {
  return "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/[x]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return r.toString(16);
  });
};

export const triggerDataAlert = async (payload, creds, category) => {
  const { serialNo, vehicleKey, actual } = payload || {};
  const iotDataInstance = await iotData(creds);
  return iotDataInstance
    .publish({
      topic: topics.DATA_TOPIC.replace("+", serialNo),
      payload: JSON.stringify({
        data: {
          batteryLevel:
            category === ALERT_CATEGORY.BATTERY_ALERT ? parseInt(actual) : 50,
          charged: true,
          engineRpm: 0,
          leftFrontTyrePressure:
            category === ALERT_CATEGORY.LOW_TYRE_PRESSURE_ALERT
              ? parseInt(actual)
              : 30,
          leftRearTyrePressure:
            category === ALERT_CATEGORY.LOW_TYRE_PRESSURE_ALERT
              ? parseInt(actual)
              : 30,
          rightFrontTyrePressure: 30,
          rightRearTyrePressure: 30,
          speed: 0,
          temperature: 0,
        },
        id: generateUniqSerial(),
        serialNo,
        timeStamp: new Date().getTime(),
        type: "vehicledata",
        vehicleKey,
      }),
      qos: 0,
      retain: false,
    })
    .promise();
};

export const sendLiveLogsData = async ({ queryKey }) => {
  console.log("Sending live logs data", queryKey);
  const [_, creds, payload] = queryKey;
  const { serialNo } = payload || {};
  const iotDataInstance = await iotData(creds);
  return iotDataInstance
    .publish({
      topic: topics.DATA_TOPIC.replace("+", serialNo),
      payload: JSON.stringify(payload),
      qos: 0,
      retain: false,
    })
    .promise();
};

export const sendDTCSignal = async ({ queryKey }) => {
  const [_, creds, payload] = queryKey;
  const { serialNo } = payload || {};
  const iotDataInstance = await iotData(creds);
  return iotDataInstance
    .publish({
      topic: topics.DTC_TOPIC.replace("+", serialNo),
      payload: JSON.stringify(payload),
      qos: 0,
      retain: false,
    })
    .promise();
};

export const uploadFileToS3 = async (file, key, creds) => {
  const s3 = new S3({
    region: process.env.REACT_APP_AWS_REGION,
    credentials: creds,
  });

  const params = {
    Bucket: process.env.REACT_APP_AWS_LIVELOGS_BUCKET, // Use the bucket name from environment variables
    Key: key,
    Body: file,
    ContentType: file.type,
  };

  return s3.upload(params).promise();
};

export const uploadTripFileToS3 = async (file, key, creds) => {
  const s3 = new S3({
    region: process.env.REACT_APP_AWS_REGION,
    credentials: creds,
  });

  const params = {
    Bucket: process.env.REACT_APP_VEHICLE_LOCATION_UPDATES_STORAGE_BUCKET, // Use the bucket name from environment variables
    Key: key,
    Body: file,
    ContentType: file.type,
  };

  return s3.upload(params).promise();
};
export const getS3FileUrl = (bucketName, key) => {
  return `https://${bucketName}.s3.amazonaws.com/${key}`;
};

export async function connect_websocket(credentials, type) {
  return await new Promise((resolve, reject) => {
    let config =
      iot.AwsIotMqttConnectionConfigBuilder.new_builder_for_websocket()
        .with_clean_session(true)
        .with_client_id("test-" + Math.floor(Math.random() * 100000000))
        .with_endpoint("a3p0q0u1ruwh8a-ats.iot.us-east-2.amazonaws.com")
        .with_credentials(
          "us-east-2",
          credentials.accessKeyId,
          credentials.secretAccessKey,
          credentials.sessionToken
        )
        .with_keep_alive_seconds(30)
        .build();
    const client = new mqtt.MqttClient();

    const connection = client.new_connection(config);
    connection.on("connect", (session_present) => {
      console.log("connected");
      resolve(connection);
    });
    connection.on("interrupt", (error) => {
      console.log("interrupted");
    });
    connection.on("resume", (return_code, session_present) => {
      console.log("resume");
    });
    connection.on("disconnect", () => {
      console.log("disconnect");
    });
    connection.on("error", (error) => {
      console.error(error);

      reject(error);
    });
    connection.connect();
  });
}

export const subscribeToShadowDelta = async (connection, serialNo, callback) => {
  const topic = topics.SHADOW_DELTA_TOPIC.replace('+', serialNo);
  await connection.subscribe(topic, mqtt.QoS.AtLeastOnce, (topic, payload, dup, qos, retain) => {
    const json = new TextDecoder("utf-8").decode(new Uint8Array(payload));
    const data = JSON.parse(json);
    callback(data);
  });
};
